import { useState } from "react";
import { Linkedin, Twitter, Link2, Check } from "lucide-react";
import type { Locale } from "@/lib/i18n";

interface Props {
  url: string;
  title: string;
  locale: Locale;
  className?: string;
}

export function ShareButtons({ url, title, locale, className = "" }: Props) {
  const [copied, setCopied] = useState(false);
  const isEs = locale === "es";
  const t = {
    label: isEs ? "Compartir" : "Share",
    x: isEs ? "Compartir en X" : "Share on X",
    li: isEs ? "Compartir en LinkedIn" : "Share on LinkedIn",
    copy: isEs ? "Copiar enlace" : "Copy link",
    copied: isEs ? "¡Copiado!" : "Copied!",
  };
  const xHref = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`;
  const liHref = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;

  const onCopy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      /* ignore */
    }
  };

  const pill =
    "inline-flex items-center gap-2 rounded-full border border-border px-3 py-1.5 text-xs font-medium text-muted-foreground transition-colors hover:border-foreground/40 hover:text-foreground";

  return (
    <div className={`flex flex-wrap items-center gap-3 ${className}`}>
      <span className="text-[10px] font-semibold uppercase tracking-[0.24em] text-muted-foreground">
        {t.label}
      </span>
      <a href={xHref} target="_blank" rel="noopener noreferrer" aria-label={t.x} className={pill}>
        <Twitter className="h-3.5 w-3.5" aria-hidden />
        <span>X</span>
      </a>
      <a href={liHref} target="_blank" rel="noopener noreferrer" aria-label={t.li} className={pill}>
        <Linkedin className="h-3.5 w-3.5" aria-hidden />
        <span>LinkedIn</span>
      </a>
      <button type="button" onClick={onCopy} aria-label={t.copy} className={pill}>
        {copied ? (
          <Check className="h-3.5 w-3.5" aria-hidden />
        ) : (
          <Link2 className="h-3.5 w-3.5" aria-hidden />
        )}
        <span>{copied ? t.copied : t.copy}</span>
      </button>
    </div>
  );
}